module.exports = __webpack_public_path__ + "img/mastercard.dced8be9.svg";